<div
  class="absolute top-full z-mobileNav flex h-screen w-72 max-w-full cursor-default flex-col gap-2 overflow-hidden bg-overlay py-2 transition-all duration-300 ease-in-out xl:top-[45px] xl:right-[15px] xl:flex xl:h-fit xl:w-48 xl:rounded-[5px] xl:shadow-lg"
  [ngClass]="{
    'xl:hidden': !open,
    'right-0': open,
    '-right-72': !open,
  }"
>
  @if (!isSoftLogin) {
    <!-- Clock buttons -->
    <ng-container *permission="['Clock time', 'Clock own time']; department: 'any'; user: 'me'">
      @if (!(headerService.clockState$ | async)?.Timesheet?.active_clock) {
        <sb-profile-clock-in-item></sb-profile-clock-in-item>
      }
      @if ((headerService.clockState$ | async)?.Timesheet?.active_clock) {
        <sb-profile-clock-out-item></sb-profile-clock-out-item>
        @if (headerService.showSwitchButton$ | async) {
          <sb-profile-clock-switch-item></sb-profile-clock-switch-item>
        }
      }
    </ng-container>

    <ng-container *subscriptionPlan="planType.BASIC">
      <!-- Requests -->
      <sb-profile-item
        (click)="headerService.supervisorRequestsSidebarOpen$.next(true)"
        *permission="['Approve absentee', 'Approve exchange']; user: 'me'; department: 'any'"
        [title]="'Requests' | translate"
        [notificationCount]="supervisorOpenRequests()"
      ></sb-profile-item>

      <!-- My Requests -->
      <sb-profile-item
        (click)="headerService.myRequestsSidebarOpen$.next(true)"
        [title]="'My Requests' | translate"
        [notificationCount]="myOpenRequests()"
      ></sb-profile-item>

      <!-- Divider -->
      <hr sbDivider />
    </ng-container>

    <!-- My profile -->
    <sb-profile-item
      *permission="['View own profile', 'Edit own profile']; user: 'me'; department: 'any'"
      routerLink="/my-account/profile"
      [title]="'My profile' | translate"
    ></sb-profile-item>

    <!-- My login -->
    <sb-profile-item routerLink="/my-account/login" [title]="'My login' | translate"></sb-profile-item>

    <!-- My notifications -->
    <sb-profile-item routerLink="/my-account/notifications" [title]="'My notifications' | translate"></sb-profile-item>

    <!-- My files -->
    <sb-profile-item
      *subscriptionPlan="planType.BASIC"
      routerLink="/my-account/files"
      [title]="'My files' | translate"
    ></sb-profile-item>

    <!-- Divider -->
    <hr sbDivider />
    <sb-profile-item (click)="openLabsDialog()">
      <span class="flex gap-2">
        <sb-icon [name]="'flask-regular'" class="text-purple" size="xl" /> {{ 'Labs' | translate }}
      </span>
    </sb-profile-item>
    @if (Features.TMP_BETA_PROGRAM | featureFlag) {
      <sb-profile-item
        *permission="['Manage account']; user: 'me'; department: 'any'"
        routerLink="/account/settings"
        fragment="beta"
        [title]="'Shiftbase BETA' | translate"
      ></sb-profile-item>
    }

    <!-- System updates >>> TODO: Feature flag? -->
    <sb-profile-item
      *subscriptionPlan="planType.BASIC"
      href="https://help.shiftbase.com/release-notes"
      [title]="'System updates' | translate"
    ></sb-profile-item>
  }

  <!-- Logout -->
  <sb-profile-item routerLink="/logout" [title]="'Log out' | translate"></sb-profile-item>
</div>
<!-- Backdrop -->
<div
  class="absolute top-full right-0 z-mobileNavBackdrop mt-px h-screen w-screen bg-scrim transition-all duration-800 ease-in-out xl:hidden"
  [ngClass]="{ invisible: !open, 'opacity-80': open, 'opacity-0': !open }"
  (click)="headerService.profileDropdownOpen$.next(false)"
></div>
